import React, { useState } from 'react';
import { Activity, Repeat } from 'lucide-react';
import { PillTabBar } from '../../../reusable';
import BudgetIncomeStructurePanel from './BudgetIncomeStructurePanel';
import BudgetVariableSalesPanel from './BudgetVariableSalesPanel';

const INCOME_TABS = [
  { key: 'recurring', label: 'Recurrentes', icon: Repeat },
  { key: 'variable', label: 'Variables', icon: Activity },
];

const BudgetIncomeSection = (props) => {
  const [incomeTab, setIncomeTab] = useState('recurring');

  return (
    <div>
      <PillTabBar
        ariaLabel="Tipos de ingreso"
        items={INCOME_TABS}
        activeKey={incomeTab}
        onChange={setIncomeTab}
        style={{ marginBottom: 12 }}
      />
      {incomeTab === 'recurring' ? <BudgetIncomeStructurePanel {...props} /> : null}
      {incomeTab === 'variable' ? <BudgetVariableSalesPanel {...props} /> : null}
    </div>
  );
};

export default BudgetIncomeSection;
